import React from 'react';

const UserGroup = ({ tickets, users }) => {

  const userMap = users.reduce((map, user) => {
    map[user.id] = user.name; 
    return map;
  }, {});

  return (
    <div className="kanban-board">
      {Object.keys(tickets).map((userId) => (
        <div key={userId} className='kanban-column'>
          <div className='col-title'>
            <h2>{userMap[userId] || 'Unknown User'}</h2>
            <div className='fix'>
            <img src="./images/3 dot menu.svg" alt="" width={20}/>
            <img src="./images/add.svg" alt="" width={20} />
            </div>
          </div>
          {tickets[userId].map((ticket) => (
            <div key={ticket.id} className=" ticket">
              <p>{ticket.id}</p>
              <div style={{display:"flex",gap:"0.5rem"}}>
              <img src={`./images/${ticket.status}.svg`} alt=""/>
                <h3>{ticket.title}</h3>
              </div>
              <div className='fix'>
                 <img src={`./images/${ticket.priority}.svg`} alt=""/>
              <p>{ticket.tag.join(', ')}</p>
              </div>
              
            </div>
          ))}
        </div>

      ))}
    </div>
  );
};

export default UserGroup;
